import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

interface BreadcrumbItem {
  label: string | any;
  href?: string | undefined;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

interface DynamicBreadcrumbsProps {
  items: BreadcrumbItem[];
  onBreadcrumbClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, item: BreadcrumbItem) => void;
}

const DynamicBreadcrumbs: React.FC<DynamicBreadcrumbsProps> = ({ items, onBreadcrumbClick }) => {
  
  const handleClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    item: BreadcrumbItem
  ) => {
    event.preventDefault();
    if (item.onClick) {
      item.onClick(event);
    }
    if (onBreadcrumbClick && item) {
      onBreadcrumbClick(event, item);
    }
  };

  return (
    <Breadcrumbs 
      separator={<NavigateNextIcon fontSize="small" />} 
      aria-label="breadcrumb"
      sx={{ cursor: "pointer" }}
    >
      {items?.map((item, index) => {
        const isLast = index === items.length - 1;

        if (isLast) {
          return (
            <Typography key={index} sx={{ color: 'text.primary' }}>
              {item?.label}
            </Typography>
          );
        }

        return (
          <Link
            key={index}
            color="primary"
            underline="none"
            sx={{
              '&:hover': {
                textDecoration: 'none',
              },
              cursor: 'pointer',
            }}
            onClick={(event) => handleClick(event, item)}
          >
            {item?.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default DynamicBreadcrumbs;
